module.exports = __webpack_public_path__ + "img/xinmaizhushe.097c83b8.png";